export enum OvertimeType {
Overtime,
Overwork,
}
